'use client'

import { useEffect, useState, useRef } from 'react'

export default function FieldToastIndicator({ 
    message, 
    backgroundColor = '#DC2626', 
    visible = false, 
    position = 'right',
    placement = 'bottom'
}) {
    const [isVisible, setIsVisible] = useState(visible)
    const toastRef = useRef(null)
    const timeoutRef = useRef(null)

    useEffect(() => {
        if (visible) {
            setIsVisible(true)
            
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }

            timeoutRef.current = setTimeout(() => {
                setIsVisible(false)
            }, 3000)

            if (toastRef.current) {
                const rect = toastRef.current.getBoundingClientRect()
                const isInViewport = (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                )

                if (!isInViewport) {
                    toastRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    })
                }
            }
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [visible, message])

    if (!message || !isVisible) return null
    
    const getPositionClasses = () => {
        const horizontalClass = position === 'right' ? 'right-0' : 'left-0'
        const verticalClass = placement === 'bottom' ? 'top-full mt-2' : 'bottom-full mb-2'
        return `absolute ${horizontalClass} ${verticalClass}`
    }
    
    return (
        <div
            ref={toastRef}
            className={`
                ${getPositionClasses()}
                px-3 py-2 rounded-md text-sm text-white z-50
                animate-fade-in-down
            `}
            style={{ backgroundColor }}
        >
            {message}
        </div>
    )
}
